/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-lone-blocks */

import { useState , useEffect } from  "react" ;
import { useForm , SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { get_H_M } from "utils/time/time"
import {useDispatch, useSelector} from "react-redux";
import {useUpdate_Data} from "hooks/ajax_crud/useAjax_Update";
import {set_Side_Panel} from "store/actions/action_Global_Layout";
import { useRating_Options } from "hooks/layout/useRating"
import Pet_Info_Title from "components/beautician/main_components/pet_info/Pet_Info_Title"

import { set_Current_Pet_Is_Done } from "store/actions/action_Beautician"



type Inputs = {

    entanglement : string ;
    dog_Hair     : string ;
    aggressive   : string ;
    eye          : string ;
	eyestatus : string ;
    ear          : string ;
	earstatus    : string ;
    skin         : string ;
    body         : string ;
    way          : string ;
    star         : string ;
	harm         : string ;
	harm_head         : string ;
	harm_torso        : string ;
	harm_limbs         : string ;
	harm_tail         : string ;

    beautician_Note : string ;

} ;


{ /*  處理結果面板  */ }
const Inform_Customer_Options = () => {

    const dispatch           = useDispatch() ;


    // 目前處理 _ 美容師姓名
    const current_Beautician = useSelector(( state : any ) => state.Beautician.Current_Beautician ) ;

    // 目前所點選 _ 寵物 / 服務
    const Current_Pet        = useSelector( ( state : any ) => state.Beautician.Current_Pet ) ;

    // 更新函式
    const update_Data        = useUpdate_Data() ;

    // 開始等待時間
    const [ time , set_Time ]               = useState('00 : 00' ) ;

    // 所有檢查項目皆正常
    const [ is_All_Good , set_Is_All_Good ] = useState(false ) ;


    // React Hook Form
    const { register  , handleSubmit , setValue , formState: { errors , isDirty , isValid } } =
        useForm<Inputs>({
                          mode : "all" ,
                        }) ;


    // 評分選項
    const rating_Options = useRating_Options( '美容師評分', 'beautician_Rating', register , setValue ) ;

    // ---------------------------------------------------------------------

    // 點選 _ 所有檢查項目皆正常
    const click_Is_All_Good = ( bool : boolean ) => set_Is_All_Good( !bool ) ;

    // 點選 _ 時間
    const click_Time = () => set_Time( time === '00 : 00' ? get_H_M() : '00 : 00' ) ;

    

    // 提交 _ 表單 ( 有問題 2016.06.16  )
    const onSubmit : SubmitHandler<Inputs> = ( data : any ) => {

            if( !Current_Pet['service_type'] ){
               alert('尚未選擇左側處理項目') ;
               return false ;
            }

        // ---------------------------------------------------------


            let check_Items = [ ] ;  // 檢查項目
            let service_Id  = '' ;   // 服務單 id
            let api         = '' ;   // api 路徑


        // ----------------------------------------------------------------------------------

            // 單選
            if( data['entanglement'] ) check_Items.push(' 打結:' + data['entanglement'] ) ;
            if( data['dog_Hair'] )     check_Items.push(' 廢毛:' + data['dog_Hair'] ) ;
			if( data['eye'] ) {         
				if( data['eyestatus'] ) {
					check_Items.push( ' ' + data['eye'] + ':' + data['eyestatus'].join(',')) ;
				} else {
					//check_Items.push( ' ' + data['eye'] ) ;
				}				
			}
            if( data['ear'] ) {
				if( data['earstatus'] ) {
					check_Items.push( ' ' + data['ear'] + ':' + data['earstatus'].join(',')) ;
				} else {
					//check_Items.push( ' ' + data['ear'] ) ;
				}
			}
            // 複選			
            if( data['skin'] )       check_Items.push( ' 皮膚:' + data['skin'].join(',') ) ;
			if( data['aggressive'] ) check_Items.push( ' 會兇:' + data['aggressive'].join(',') ) ;
			if( data['body'] )       check_Items.push( ' 體外:' + data['body'].join(',') ) ;
			
			if( data['harm_head'] ) {
				check_Items.push( ' 頭原本受傷部位:' + data['harm_head'].join(',')) ;
			}
			if( data['harm_torso'] ) {
				check_Items.push( ' 軀幹原本受傷部位:' + data['harm_torso'].join(',')) ;
			}
			if( data['harm_limbs'] ) {
				check_Items.push( ' 四肢原本受傷部位:' + data['harm_limbs'].join(',')) ;
			}
			if( data['harm_tail'] ) {
				check_Items.push( ' 尾巴原本受傷部位:' + data['harm_tail'].join(',')) ;
			}				
			if( data['harm'] ) {
				check_Items.push( ' 本次受傷部位:' + data['harm'].join(',')) ;	
			}

            // 設定 : service_Id、api
            if( Current_Pet['service_type'] === '基礎' ){ service_Id = Current_Pet['basic_id'] ;  api = '/basics'   } ;
            if( Current_Pet['service_type'] === '洗澡' ){ service_Id = Current_Pet['bath_id'] ;   api = '/bathes'   } ;
            if( Current_Pet['service_type'] === '美容' ){ service_Id = Current_Pet['beauty_id'] ; api = '/beauties' } ;


            // 驗證是否點選 _ 檢查項目
            if( check_Items.length === 0  && !is_All_Good ){
				set_Is_All_Good(true);//原非同步改寫麻煩，後台處理，但目前為前台處理
                //alert('請點選確認 :　檢查項目')　;
                //return false ;
            }

            if( time === '00 : 00' ){
				click_Time();//原非同步改寫麻煩，後台處理，但目前為前台處理
                //alert( '請點選時間' ) ;
                //return false ;
            }

            // 美容師檢查項目
            const beautician_Report = is_All_Good ? '所有檢查項目皆正常' : check_Items.join(',') ;

            // 更新欄位
            let obj = {

                          beautician_name   : current_Beautician ? current_Beautician : '測試員' ,
                          beautician_report : beautician_Report ,

                          wait_way          : data['way'] ,
                          wait_time         : time ,

                          beautician_star   : data['beautician_Rating']  ,
                          beautician_note   : data['beautician_Note'] ,

                          shop_status       : '洗完等候中'

                        } ;
		
		if( check_Items.length === 0  && !is_All_Good ){
			if( time === '00 : 00' ){
				obj = {

                          beautician_name   : current_Beautician ? current_Beautician : '測試員' ,
                          beautician_report : beautician_Report ,

                          wait_way          : '所有檢查項目皆正常' ,
                          wait_time         : get_H_M() ,

                          beautician_star   : data['beautician_Rating']  ,
                          beautician_note   : data['beautician_Note'] ,

                          shop_status       : '洗完等候中'

                        } ;
			} else {
				obj = {

                          beautician_name   : current_Beautician ? current_Beautician : '測試員' ,
                          beautician_report : beautician_Report ,

                          wait_way          : '所有檢查項目皆正常' ,
                          wait_time         : time ,

                          beautician_star   : data['beautician_Rating']  ,
                          beautician_note   : data['beautician_Note'] ,

                          shop_status       : '洗完等候中'

                        } ;
			}
        } else {
			if( time === '00 : 00' ){
				obj = {

                          beautician_name   : current_Beautician ? current_Beautician : '測試員' ,
                          beautician_report : beautician_Report ,

                          wait_way          : data['way'] ,
                          wait_time         : get_H_M() ,

                          beautician_star   : data['beautician_Rating']  ,
                          beautician_note   : data['beautician_Note'] ,

                          shop_status       : '洗完等候中'

                        } ;
			} else {
				obj = {

                          beautician_name   : current_Beautician ? current_Beautician : '測試員' ,
                          beautician_report : beautician_Report ,

                          wait_way          : data['way'] ,
                          wait_time         : time ,

                          beautician_star   : data['beautician_Rating']  ,
                          beautician_note   : data['beautician_Note'] ,

                          shop_status       : '洗完等候中'

                        } ;
			}
		}

        // 更改欄位
        update_Data( api , service_Id , obj , '/beautician' , null , '處理結果已提交櫃台'  ) ;

        // 關掉 _ 右側滑動面板
        dispatch( set_Side_Panel(false , null ,{} ) ) ;

        // 關掉 _ 右側寵物資訊主畫面
        dispatch( set_Current_Pet_Is_Done( true ) );


    } ;


    // 若所點選 "所有檢查項目皆正常" -> 清除點選項目
    useEffect( () => {

       if( is_All_Good ){

           setValue('entanglement' , '' ) ;
           setValue('dog_Hair'     , '' ) ;
           setValue('eye'          , '' ) ;
		   setValue('eyestatus'          , '' ) ;
           setValue('ear'          , '' ) ;
		   setValue('earstatus'          , '' ) ;

           setValue('body'         , '' ) ;
           setValue('skin'         , '' ) ;
           setValue('aggressive'   , '' ) ;
		   setValue('harm'   , '' ) ;
		   setValue('harm_head'   , '' ) ;
		   setValue('harm_torso'   , '' ) ;
		   setValue('harm_limbs'   , '' ) ;
		   setValue('harm_tail'   , '' ) ;

       }


    } ,[ is_All_Good ] ) ;




    // 預先填寫美容師備註
    useEffect( () => {

       if( Current_Pet?.beautician_note ) setValue( "beautician_Note" , Current_Pet.beautician_note ) ;   

    } , [ Current_Pet ] )


   return <div className="relative">

               <b className="absolute f_14" style={{ top:"5px" , right : "70px" }}>
                   美容師 : <span className="fDred"> { current_Beautician ? current_Beautician : '測試員'  } </span>
               </b>

               { Current_Pet['service_type'] ? <Pet_Info_Title />  : <b className="tag is-large is-danger"> <i className="fas fa-exclamation"></i> &nbsp; 尚未選擇服務 </b>  }

               <br/><hr/><br/>

               <form onSubmit = { handleSubmit( onSubmit ) } >

                   <div className="columns is-multiline is-mobile" >

                       { /* 所有項目皆正常 */ }
                       <div className="column is-12-desktop" >

                           <div className = { is_All_Good ? 'tag is-large w-full is-success' : 'tag is-large hover w-full' }
                                onClick   = { () => click_Is_All_Good( is_All_Good ) } >
                               <b> <i className="fas fa-check-circle" ></i> &nbsp; 所 有 檢 查 項 目 皆 正 常 </b>
                           </div>

                       </div>

                       { /* 檢查項目 */}
                       { is_All_Good ||

                           <>
                               <div className="column is-12-desktop p-1 is-lightbluegray">
                                   <b className="tag is-size-4 is-lightbluegray"> 打 結 : </b> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="radio" value="輕"  {...register("entanglement")} /> 輕 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="radio" value="中"  {...register("entanglement")} /> 中 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="radio" value="重"  {...register("entanglement")} /> 重 </label> &nbsp; &nbsp;
                               </div>

                               <div className="column is-12-desktop p-1 is-warmlightbeige">
                                   <b className="tag is-size-4 is-warmlightbeige"> 廢 毛 : </b> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="radio" value="輕"  {...register("dog_Hair")} /> 輕 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="radio" value="中"  {...register("dog_Hair")} /> 中 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="radio" value="重"  {...register("dog_Hair")} /> 重 </label> &nbsp; &nbsp;
                               </div>

                               <div className="column is-12-desktop p-1 is-lightbluegray">
                                   <b className="tag is-size-4 is-lightbluegray"> 眼 睛 : </b> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="radio" value="左眼"     {...register("eye")} /> 左眼 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="radio" value="右眼"     {...register("eye")} /> 右眼 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="radio" value="兩眼"     {...register("eye")} /> 兩眼 </label> &nbsp; &nbsp;
                               </div>
							   
							   <div className="column is-12-desktop p-1 is-warmlightbeige">
                                   <b className="tag is-size-4 is-warmlightbeige"> 眼 睛 狀 況 : </b> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="紅"     {...register("eyestatus")} /> 紅 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="紅腫" {...register("eyestatus")} /> 紅腫 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="瞇瞇眼 "     {...register("eyestatus")} /> 瞇瞇眼 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="有外傷" {...register("eyestatus")} /> 有外傷 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="建議看醫生" {...register("eyestatus")} /> 建議看醫生 </label> &nbsp; &nbsp;
                                   <span className="fDblue"> ( 可複選 ) </span>
                               </div>

                               <div className="column is-12-desktop p-1 is-lightbluegray">
                                   <b className="tag is-size-4 is-lightbluegray"> 耳 朵 : </b> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="radio" value="左耳"     {...register("ear")} /> 左耳 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="radio" value="右耳"     {...register("ear")} /> 右耳 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="radio" value="兩耳"     {...register("ear")} /> 兩耳 </label> &nbsp; &nbsp;
                               </div>
							   
							   <div className="column is-12-desktop is-warmlightbeige">
                                   <b className="tag is-size-4 is-warmlightbeige"> 耳 朵 狀 況 : </b> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="黃色分泌物"     {...register("earstatus")} /> 黃色分泌物 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="咖啡色分泌物"     {...register("earstatus")} /> 咖啡色分泌物 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="灰綠色分泌物" {...register("earstatus")} /> 灰綠色分泌物 </label> &nbsp; &nbsp; <br /> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="出血 "     {...register("earstatus")} /> 出血 </label> &nbsp; &nbsp; 
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="紅"     {...register("earstatus")} /> 紅 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="紅腫" {...register("earstatus")} /> 紅腫 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="有外傷" {...register("earstatus")} /> 有外傷 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="建議看醫生" {...register("earstatus")} /> 建議看醫生 </label> &nbsp; &nbsp;
                                   <span className="fDblue"> ( 可複選 ) </span>
                               </div>

                               <div className="column is-12-desktop p-1 is-lightbluegray">
                                   <b className="tag is-size-4 is-lightbluegray"> 皮 膚 : </b> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="少毛"   {...register("skin")} /> 少毛 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="皮屑"   {...register("skin")} /> 皮屑 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="略紅"   {...register("skin")} /> 略紅 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="紅點"   {...register("skin")} /> 紅點 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="結痂"   {...register("skin")} /> 結痂 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="有外傷"   {...register("skin")} /> 有外傷 </label> &nbsp; &nbsp; <br /> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="建議看醫生"   {...register("skin")} /> 建議看醫生 </label> &nbsp; &nbsp;
								   
                                   <span className="fDblue"> ( 可複選 ) </span>

                               </div>

                               <div className="column is-12-desktop p-1 is-warmlightbeige">

                                   <b className="tag is-size-4 is-warmlightbeige"> 會 兇 : </b> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="擠肛門腺" {...register("aggressive")} /> 擠肛門腺 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="碰頭"     {...register("aggressive")} /> 碰頭 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="剪指甲"   {...register("aggressive")} /> 剪指甲 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="清耳朵"   {...register("aggressive")} /> 清耳朵 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="其他"     {...register("aggressive")} /> 其他 </label> &nbsp; &nbsp;

                                   <span className="fDblue"> ( 可複選 ) </span>

                               </div>
							   
							   <div className="column is-12-desktop p-1 is-lightbluegray">
                                   <b className="tag is-size-4 is-lightbluegray"> 體 外 : </b> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="壁蝨"     {...register("body")} /> 壁蝨 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="跳蚤"     {...register("body")} /> 跳蚤 </label> &nbsp; &nbsp;
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="建議點藥" {...register("body")} /> 建議點藥 </label> &nbsp; &nbsp;
                                   <span className="fDblue"> ( 可複選 ) </span>
                               </div>
							   
							   <div className="column is-12-desktop p-1 is-warmlightbeige">
                                   <b className="tag is-size-4 is-warmlightbeige"> 頭原本受傷部位 : </b> &nbsp; &nbsp;								   
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="耳朵"     {...register("harm_head")} /> 耳朵 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="臉頰"     {...register("harm_head")} /> 臉頰 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="脖子"     {...register("harm_head")} /> 脖子 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="後腦"     {...register("harm_head")} /> 後腦 </label> &nbsp; &nbsp;
								   <span className="fDblue"> ( 可複選 ) </span>
                               </div>
							   
							   <div className="column is-12-desktop p-1 is-lightbluegray">
                                   <b className="tag is-size-4 is-lightbluegray "> 軀幹原本受傷部位 : </b> &nbsp; &nbsp;								   
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="上背"     {...register("harm_torso")} /> 上背 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="後背"     {...register("harm_torso")} /> 後背 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="胸"     {...register("harm_torso")} /> 胸 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="下腹"     {...register("harm_torso")} /> 下腹 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="屁股"     {...register("harm_torso")} /> 屁股 </label> &nbsp; &nbsp;
								   <span className="fDblue"> ( 可複選 ) </span>
                               </div>
							   
							   <div className="column is-12-desktop p-1 is-warmlightbeige">
                                   <b className="tag is-size-4 is-warmlightbeige"> 右前腿原本受傷部位 : </b> &nbsp; &nbsp;								   
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="右前腿"     {...register("harm_limbs")} /> 右前腿 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="右前腿內側"     {...register("harm_limbs")} /> 右前腿內側 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="右前腿外側"     {...register("harm_limbs")} /> 右前腿外側 </label> &nbsp; &nbsp; <br /> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="右前腿腋下或跨下"     {...register("harm_limbs")} /> 右前腿腋下或跨下 </label> &nbsp; &nbsp;
								   <span className="fDblue"> ( 可複選 ) </span>
                               </div>
							   
							   <div className="column is-12-desktop p-1 is-lightbluegray">
                                   <b className="tag is-size-4 is-lightbluegray"> 左前腿原本受傷部位 : </b> &nbsp; &nbsp;								   
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="左前腿"     {...register("harm_limbs")} /> 左前腿 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="左前腿內側"     {...register("harm_limbs")} /> 左前腿內側 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="左前腿外側"     {...register("harm_limbs")} /> 左前腿外側 </label> &nbsp; &nbsp; <br /> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="左前腿腋下或跨下"     {...register("harm_limbs")} /> 左前腿腋下或跨下 </label> &nbsp; &nbsp;
								   <span className="fDblue"> ( 可複選 ) </span>
                               </div>
							   
							   <div className="column is-12-desktop p-1 is-warmlightbeige">
                                   <b className="tag is-size-4 is-warmlightbeige"> 右後腿原本受傷部位 : </b> &nbsp; &nbsp;								   
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="右後腿"     {...register("harm_limbs")} /> 右後腿 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="右後腿內側"     {...register("harm_limbs")} /> 右後腿內側 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="右後腿外側"     {...register("harm_limbs")} /> 右後腿外側 </label> &nbsp; &nbsp; <br /> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="右後腿腋下或跨下"     {...register("harm_limbs")} /> 右後腿腋下或跨下 </label> &nbsp; &nbsp;
								   <span className="fDblue"> ( 可複選 ) </span>
                               </div>
							   
							   <div className="column is-12-desktop p-1 is-lightbluegray">
                                   <b className="tag is-size-4 is-lightbluegray"> 左後腿原本受傷部位 : </b> &nbsp; &nbsp;								   
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="左後腿"     {...register("harm_limbs")} /> 左後腿 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="左後腿內側"     {...register("harm_limbs")} /> 左後腿內側 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="左後腿外側"     {...register("harm_limbs")} /> 左後腿外側 </label> &nbsp; &nbsp; <br /> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="左後腿腋下或跨下"     {...register("harm_limbs")} /> 左後腿腋下或跨下 </label> &nbsp; &nbsp;
								   <span className="fDblue"> ( 可複選 ) </span>
                               </div>
							   
							   <div className="column is-12-desktop p-1 is-warmlightbeige">
                                   <b className="tag is-size-4 is-warmlightbeige"> 尾巴原本受傷部位 : </b> &nbsp; &nbsp;								   
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="尾巴整條"     {...register("harm_tail")} /> 尾巴整條 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="尾巴局部"     {...register("harm_tail")} /> 尾巴局部 </label> &nbsp; &nbsp;
								   <span className="fDblue"> ( 可複選 ) </span>
                               </div>
							   
							   <div className="column is-12-desktop p-1 is-lightbluegray">
                                   <b className="tag is-size-4 is-lightbluegray"> 本次受傷 : </b> &nbsp; &nbsp;								   
                                   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="全身"     {...register("harm")} /> 全身 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="頭"     {...register("harm")} /> 頭 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="軀幹"     {...register("harm")} /> 軀幹 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="四肢"     {...register("harm")} /> 四肢 </label> &nbsp; &nbsp;
								   <label className="is-size-4 has-text-weight-semibold"><input type="checkbox" value="尾巴"     {...register("harm")} /> 尾巴 </label> &nbsp; &nbsp;
								   <span className="fDblue"> ( 可複選 ) </span>
                               </div>

                           </>

                       }

                   </div>
				   <div className="has-text-centered" >
					<button  type="submit" className="button is-primary relative is-medium"  >
                     提交表單
					</button>
				   </div>
				   <hr/>
					   
                   { /* 美容師後續處理 */ }
                   <div className="columns is-multiline is-mobile" >

                       <div className="column is-12-desktop" >

                           <i className="fas fa-door-open"></i>&nbsp;<b className="tag is-medium is-warmlightbeige"> 洗澡 / 美容後處理方式 : </b> &nbsp; &nbsp;

                           <div className="select is-normal relative" >
                               <select { ...register( "way" ) }>
                                   <option value = "進籠子_等候" > 進籠子 _ 等候 </option>
                                   <option value = "運動場_等候" > 運動場 _ 等候 </option>
                                   <option value = "美容桌_等候">  美容桌 _ 等候 </option>
                               </select>
                           </div>  &nbsp; &nbsp; &nbsp; &nbsp;

                           <b className= { time === '00 : 00' ? "tag is-large hover" : "tag is-large is-success" }  onClick={ click_Time } > { time } </b>

                       </div>

                       { /* 評分選項 */ }
                       { rating_Options }
                       <div className="column is-11-desktop" >

                           <i className="fas fa-pencil-alt"></i>&nbsp;<b className="tag is-medium is-warmlightbeige"> 美容師備註 : </b> &nbsp; &nbsp;

                           {/* 
                                <div className="select is-normal realtive" >
                                    <select { ...register( "beautician_Note" ) }>
                                        <option value="請選擇"> 請選擇 </option>
                                        <option value="會咬人"> 會咬人 </option>
                                        <option value="廢毛太多"> 廢毛太多 </option>
                                        <option value="過動、不好處理"> 過動、不好處理 </option>
                                    </select>
                                </div> 
                            */}

                            <textarea  rows={8} cols={20} className="textarea relative" {...register("beautician_Note")} placeholder="備註事項"
                                       style={{color: "rgb(0,0,180)", fontWeight: "bold" , left:"35px" }}/>


                       </div>

                   </div>

                  

                   <div className="has-text-centered m_Top_80 m_Bottom_50" >
                       <button  type="submit" className="button is-primary relative is-medium"  >
                           提交表單
                       </button>
                   </div> 

               </form>

            </div>



};

export default Inform_Customer_Options